import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import { Bar, BarChart, CartesianGrid, ReferenceLine, XAxis, YAxis } from "recharts";

const EXPERIMENTS_GOAL = 5;

const chartConfig = {
  concluded_count: {
    label: "Concluded experiments",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

type WeekPoint = { week_start_utc: string; concluded_count: number };

type ExperimentsChartProps = {
  data: WeekPoint[];
};

function fillZeroWeeks(data: WeekPoint[]): WeekPoint[] {
  const dataMap = new Map(data.map(d => [d.week_start_utc, d.concluded_count]));
  const result: WeekPoint[] = [];

  const yearStart = new Date(Date.UTC(2026, 0, 1));
  const dayOfWeek = yearStart.getUTCDay();
  const daysToMonday = dayOfWeek === 0 ? 1 : dayOfWeek === 1 ? 0 : 8 - dayOfWeek;
  const current = new Date(yearStart);
  current.setUTCDate(current.getUTCDate() + daysToMonday);

  const now = new Date();
  while (current <= now) {
    const weekStr = current.toISOString().slice(0, 10);
    result.push({ week_start_utc: weekStr, concluded_count: dataMap.get(weekStr) ?? 0 });
    current.setUTCDate(current.getUTCDate() + 7);
  }
  return result;
}

export function ExperimentsChart({ data }: ExperimentsChartProps) {
  const filledData = fillZeroWeeks(data);
  return (
    <ChartContainer config={chartConfig} className="min-h-[200px]">
      <BarChart data={filledData}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="week_start_utc" tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        <ReferenceLine
          y={EXPERIMENTS_GOAL}
          stroke="hsl(var(--chart-2))"
          strokeDasharray="4 4"
          label={{
            value: `Goal: ${EXPERIMENTS_GOAL}`,
            position: "insideTopRight",
            fill: "hsl(var(--chart-2))",
            fontSize: 12,
          }}
        />
        <Bar dataKey="concluded_count" fill="var(--color-concluded_count)" radius={4} />
      </BarChart>
    </ChartContainer>
  );
}
